import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import { WhatsAppButton } from '@/components'

const Layout: React.FC = () => {
  const location = useLocation()
  const isHomePage = location.pathname === '/'
  const isRobotPage = location.pathname === '/robot'
  const isBlogPage = location.pathname.startsWith('/blog/')
  const isPrivacyPage = location.pathname === '/privacy'
  const isTransparentPage = isHomePage || isRobotPage || isBlogPage || isPrivacyPage

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className={`flex-1 ${!isTransparentPage ? 'pt-16' : ''}`}>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  )
}

export default Layout 